import React, { useState } from 'react';
import { images } from '../mockData';
import { X } from 'lucide-react';

const ImageModal = ({ src, alt, onClose }) => {
  return (
    <div 
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
      >
        <X className="w-6 h-6" />
      </button>
      <img 
        src={src} 
        alt={alt} 
        className="max-w-full max-h-full object-contain"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default ImageModal;
